import React, { useState } from 'react';
import './booking.css';
import emailjs from 'emailjs-com';


function Bookings() {
  const [activeTab, setActiveTab] = useState('one-way');
  const [formData, setFormData] = useState({
    tripType: 'one-way',
    pickupLocation: '',
    dropoffLocation: '',
    pickupDate: '',
    pickupTime: '',
    vehicleType: '',
    passengers: 1,
    name: '',
    email: '',
    phone: '',
    specialRequests: ''
  });
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    // Replace the following with your EmailJS Service ID, Template ID, and Public Key
    const SERVICE_ID = 'service_ql95y5z';
    const TEMPLATE_ID = 'template_eg340ff';
    const PUBLIC_KEY = 'abH1yS1C9vfcjqQL7';

    emailjs.send(SERVICE_ID, TEMPLATE_ID, formData, PUBLIC_KEY)
      .then((response) => {
        console.log('Email sent successfully!', response.status, response.text);
        alert('Booking confirmed!');
        // Reset form
        setFormData({
          tripType: 'one-way',
          pickupLocation: '',
          dropoffLocation: '',
          pickupDate: '',
          pickupTime: '',
          vehicleType: '',
          passengers: 1,
          name: '',
          email: '',
          phone: '',
          specialRequests: ''
        });
      }, (error) => {
        console.log('Failed to send email:', error);
        alert('Failed to send email. Please try again later.');
      })
      .finally(() => {
        setLoading(false);
      });

    console.log('Booking submitted:', formData);
  };

  const vehicleTypes = [
    { value: 'Airport Tour', label: 'Airport Tour' },
    { value: 'City Rides', label: 'City Rides' },
    { value: 'Day Tour', label: 'Day Tour' },
    { value: 'Short of Long Term', label: 'Short of Long Term' },
    { value: 'Wedding Tour', label: 'Wedding Tour' },
    { value: 'Outstation Tour', label: 'Outstation Tour' }
  ];

  return (
    <section className="bookings" aria-labelledby="bookings-heading">
      <div className="bookings-container">
        {/* Hero Section */}
        <div className="bookings-hero">
          <div className="bookings-hero-content">
            <h1 id="bookings-heading" className="bookings-hero-title">
              Book Your Ride in Seconds
            </h1>
            <p className="bookings-hero-description">
              Get instant quotes, choose your preferred vehicle, and book your ride with our simple and secure booking system.
            </p>
          </div>
          <div className="bookings-hero-image">
            <img 
              src="/about_us.png" 
              alt="Easy online booking system for vehicle rentals and transportation services"
              loading="eager"
              width="600"
              height="400"
            />
          </div>
        </div>

        {/* Booking Form Section */}
        <div className="booking-form-section">
          <div className="booking-form-container">
            <div className="form-header">
              <h2>Book Your Ride</h2>
              <p>Fill in the details below to get an instant quote</p>
            </div>

            {/* Trip Type Tabs */}
            <div className="trip-type-tabs">
              <button 
                className={`tab-button ${activeTab === 'one-way' ? 'active' : ''}`}
                onClick={() => {
                  setActiveTab('one-way');
                  setFormData(prev => ({ ...prev, tripType: 'one-way' }));
                }}
              >
                One Way 
              </button>
              <button 
                className={`tab-button ${activeTab === 'Two-way' ? 'active' : ''}`}
                onClick={() => {
                  setActiveTab('Two-way');
                  setFormData(prev => ({ ...prev, tripType: 'Two-way' }));
                }}
              >
                Two Way 
              </button>
            </div>

            <form className="booking-form" onSubmit={handleSubmit}>
              {/* Location Details */}
              <div className="form-section">
                <h3 className="section-title">Trip Details</h3>
                <div className="form-grid">
                  <div className="form-group">
                    <label htmlFor="pickupLocation">Pickup Location *</label>
                    <input
                      type="text"
                      id="pickupLocation"
                      name="pickupLocation"
                      value={formData.pickupLocation}
                      onChange={handleInputChange}
                      placeholder="Enter pickup address"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="dropoffLocation">Drop-off Location *</label>
                    <input
                      type="text"
                      id="dropoffLocation"
                      name="dropoffLocation"
                      value={formData.dropoffLocation}
                      onChange={handleInputChange}
                      placeholder="Enter drop-off address"
                      required
                    />
                  </div>
                </div>
              </div>

              {/* Date & Time */}
              <div className="form-section">
                <h3 className="section-title">Date & Time</h3>
                <div className="form-grid">
                  <div className="form-group">
                    <label htmlFor="pickupDate">Pickup Date *</label>
                    <input
                      type="date"
                      id="pickupDate"
                      name="pickupDate"
                      value={formData.pickupDate}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="pickupTime">Pickup Time *</label>
                    <input
                      type="time"
                      id="pickupTime"
                      name="pickupTime"
                      value={formData.pickupTime}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  {activeTab === 'round-trip' && (
                    <>
                      <div className="form-group">
                        <label htmlFor="returnDate">Return Date *</label>
                        <input
                          type="date"
                          id="returnDate"
                          name="returnDate"
                          value={formData.returnDate}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="returnTime">Return Time *</label>
                        <input
                          type="time"
                          id="returnTime"
                          name="returnTime"
                          value={formData.returnTime}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>

              {/* Vehicle Selection */}
              <div className="form-section">
                <h3 className="section-title">Select Vehicle</h3>
                <div className="vehicle-selection">
                  {vehicleTypes.map(vehicle => (
                    <div 
                      key={vehicle.value}
                      className={`vehicle-option ${formData.vehicleType === vehicle.value ? 'selected' : ''}`}
                      onClick={() => setFormData(prev => ({ ...prev, vehicleType: vehicle.value }))}
                    >
                      <div className="vehicle-info">
                        <div className="vehicle-name">{vehicle.label}</div>
                      </div>
                      <div className="vehicle-checkbox">
                        <div className="custom-checkbox"></div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Passenger Details */}
              <div className="form-section">
                <h3 className="section-title">Passenger Details</h3>
                <div className="form-grid">
                  <div className="form-group">
                    <label htmlFor="passengers">Number of Passengers *</label>
                    <select
                      id="passengers"
                      name="passengers"
                      value={formData.passengers}
                      onChange={handleInputChange}
                      required
                    >
                      {[1, 2, 3, 4, 5, 6, 7, 8].map(num => (
                        <option key={num} value={num}>{num} {num === 1 ? 'passenger' : 'passengers'}</option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <label htmlFor="name">Your Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      placeholder="Enter your full name"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Email Address *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      placeholder="Enter your email"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="phone">Phone Number *</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      placeholder="Enter your phone number"
                      required
                    />
                  </div>
                </div>
              </div>

              {/* Special Requests */}
              <div className="form-section">
                <h3 className="section-title">Special Requests</h3>
                <div className="form-group full-width">
                  <textarea
                    id="specialRequests"
                    name="specialRequests"
                    value={formData.specialRequests}
                    onChange={handleInputChange}
                    placeholder="Any special requirements, child seats, extra luggage, etc."
                    rows="4"
                  />
                </div>
              </div>
    

              {/* Submit Button */}
              <div className="form-actions">
                <button type="submit" className="submit-button">
                  <span className="button-text">Book Now</span>
                  <span className="button-icon"></span>
                </button>
              </div>
            </form>
          </div>
        </div>



        {/* Support Section */}
        <div className="support-section">
          <div className="support-content">
            <h2>Need Help With Your Booking?</h2>
            <p>Our customer support team is available 24/7 to assist you</p>
            <div className="support-options">

              <div className="support-option">
                <a
                  href="tel:+94701707707"
                  className="support-call-link"
                >
                
                  <div className="support-info">
                    <h3>Call Us</h3>
                    <p>+94 70 170 7707</p>
                  
                  </div>
                </a>
              </div>



              <div className="support-option">
                <a
                  href="https://wa.me/94701707707"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="support-whatsapp-link"
                >
           
                  <div className="support-info">
                    <h3>Live Chat</h3>
                    <p>+94 70 170 7707</p>
                  </div>
                </a>
              </div>

              <div className="support-option">
                <a
                  href="mailto:info@retionzcabs.lk"
                  className="support-email-link"
                >
             
                  <div className="support-info">
                    <h3>Email Us</h3>
                    <p>info@retionzcabs.lk</p>
                  </div>
                </a>
              </div>




            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Bookings;